﻿import * as paths from '../../../map/utils/paths';
import * as eventTypes from '../../../map/utils/eventTypes';
import ChartFilterBuilder from '../../../../SharedControls/chartFilterBuilder';
import GridColumnEditor from '../../../../SharedControls/gridColumnEditor';
export default class ChartConfigurator {
    constructor(rootUrl, resourcesHandler, modalContainer, layerSettingsHandler, classId) {
        this.rootUrl = rootUrl;
        this.resourcesHandler = resourcesHandler;
        this.modalContainer = modalContainer;
        this.layerSettingsHandler = layerSettingsHandler;
        this.classId = classId;
        this.currentLayer = null;
        this.currentLayerFields = [];
        this.currentLayerEntityFields = [];
        this.cancelChartSettingsId = 'cancel-chart-settings-' + this.classId;
        this.saveChartSettingsId = 'save-chart-settings-' + this.classId;
        this.chartSettingsWrapper = 'chart-settings-wrapper-' + this.classId;
        this.propertySelectId = 'chart-settings-property-select-' + this.classId;
        this.chartTypeSelectId = 'chart-settings-chart-type-select-' + this.classId;
        this.chartOptionsSettingsContainer = 'chart-settings-options-container-' + this.classId
        this.samplingIntervalId = 'chart-settings-sampling-interval-' + this.classId;
        this.samplingMeasureId = 'chart-settings-sampling-measure-' + this.classId;
        this.sortingId = 'chart-settings-sorting-' + this.classId;
        this.colorPalleteId = 'chart-settings-color-pallete-' + this.classId;
        this.chartTypeCard = 'chart-type-card-' + this.classId;
        this.chartTypePie = 'chart-type-pie-' + this.classId;
        this.chartTypeBar = 'chart-type-bar-' + this.classId;
        this.chartTypeLine = 'chart-type-line-' + this.classId;
        this.chartTypeBubble = 'chart-type-bubble-' + this.classId;
        this.chartTypeGrid = 'chart-type-grid-' + this.classId;
        this.cardChartField = 'card-chart-field-' + this.classId;
        this.cardChartAggregationMethod = 'card-chart-aggregation-method-' + this.classId;
        this.cardChartFieldCondition = 'card-chart-condition-' + this.classId;
        this.cardChartTitle = 'card-chart-title-' + this.classId;
        this.cardChartBackgroundColor = 'card-chart-background-color-' + this.classId;
        this.cardChartFontColor = 'card-chart-font-color-' + this.classId;
        this.cardChartTitleFontSize = 'card-chart-title-font-size-' + this.classId;
        this.cardChartValueFontSize = 'card-chart-value-font-size-' + this.classId;
        this.cardChartCategoryField = 'card-chart-category-field-' + this.classId;
        this.cardChartMaxCategories = 'card-chart-max-categories-' + this.classId;
        this.cardChartCardsPerRow = 'card-chart-cards-per-row-' + this.classId;
        this.cardChartSortOrder = 'card-chart-sort-order-' + this.classId;
        this.cardChartColorPalette = 'card-chart-color-palette-' + this.classId;
        this.cardChartCustomColors = 'card-chart-custom-colors-' + this.classId;
        this.queryBuilderInited = false;
        this.chartFilterBuilder = new ChartFilterBuilder(() => this.currentLayerEntityFields, (k) => this.resourcesHandler.get(k));
        this.pieChartCategoryField = 'pie-chart-category-field-' + this.classId;
        this.pieChartValueField = 'pie-chart-value-field-' + this.classId;
        this.pieChartAggregationMethod = 'pie-chart-aggregation-method-' + this.classId;
        this.pieChartMaxSlices = 'pie-chart-max-slices-' + this.classId;
        this.pieChartTitle = 'pie-chart-title-' + this.classId;
        this.pieChartBackgroundColor = 'pie-chart-background-color-' + this.classId;
        this.pieChartFontColor = 'pie-chart-font-color-' + this.classId;
        this.pieChartFieldCondition = 'pie-chart-condition-' + this.classId;
        this.pieChartTitleFontSize = 'pie-chart-title-font-size-' + this.classId;
        this.pieChartLabelFontSize = 'pie-chart-label-font-size-' + this.classId;
        this.pieChartColorPalette = 'pie-chart-color-palette-' + this.classId;
        this.pieChartCustomColors = 'pie-chart-custom-colors-' + this.classId;
        this.pieChartLabelType = 'pie-chart-label-type-' + this.classId;
        this.lineChartXField = 'line-chart-x-field-' + this.classId;
        this.lineChartTitle = 'line-chart-title-' + this.classId;
        this.lineChartSortOrder = 'line-chart-sort-order-' + this.classId;
        this.lineChartBackgroundColor = 'line-chart-background-color-' + this.classId;
        this.lineChartFontColor = 'line-chart-font-color-' + this.classId;
        this.lineChartTitleFontSize = 'line-chart-title-font-size-' + this.classId;
        this.lineChartLabelFontSize = 'line-chart-label-font-size-' + this.classId;
        this.lineChartSeriesContainer = 'line-chart-series-' + this.classId;
        this.lineChartSeriesMode = 'line-chart-series-mode-' + this.classId;
        this.lineChartSplitByField = 'line-chart-split-by-field-' + this.classId;
        this.lineChartSplitValueField = 'line-chart-split-value-field-' + this.classId;
        this.lineChartSplitAggregation = 'line-chart-split-aggregation-' + this.classId;
        this.lineChartManualContainer = 'line-chart-manual-container-' + this.classId;
        this.lineChartSplitContainer = 'line-chart-split-container-' + this.classId;
        this.lineChartSplitColorPalette = 'line-chart-split-color-palette-' + this.classId;
        this.lineChartSplitCustomColors = 'line-chart-split-custom-colors-' + this.classId;
        this.lineChartFieldCondition = 'line-chart-condition-' + this.classId;
        this.lineChartAreaFill = 'line-chart-area-fill-' + this.classId;
        this.lineChartStackedArea = 'line-chart-stacked-area-' + this.classId;
        this.lineChartBarStacked = 'line-chart-bar-stacked-' + this.classId;
        this.lineChartAreaFillRow = 'line-chart-area-fill-row-' + this.classId;
        this.lineChartBarStackedRow = 'line-chart-bar-stacked-row-' + this.classId;
        this.bubbleChartNullHandling = 'bubble-chart-null-handling-' + this.classId;
        this.bubbleChartXField = 'bubble-chart-x-field-' + this.classId;
        this.bubbleChartYField = 'bubble-chart-y-field-' + this.classId;
        this.bubbleChartSizeField = 'bubble-chart-size-field-' + this.classId;
        this.bubbleChartSplitByField = 'bubble-chart-split-by-field-' + this.classId;
        this.bubbleChartMaxBubbleSize = 'bubble-chart-max-bubble-size-' + this.classId;
        this.bubbleChartTitle = 'bubble-chart-title-' + this.classId;
        this.bubbleChartBackgroundColor = 'bubble-chart-background-color-' + this.classId;
        this.bubbleChartFontColor = 'bubble-chart-font-color-' + this.classId;
        this.bubbleChartTitleFontSize = 'bubble-chart-title-font-size-' + this.classId;
        this.bubbleChartLabelFontSize = 'bubble-chart-label-font-size-' + this.classId;
        this.bubbleChartColorPalette = 'bubble-chart-color-palette-' + this.classId;
        this.bubbleChartCustomColors = 'bubble-chart-custom-colors-' + this.classId;
        this.bubbleChartFieldCondition = 'bubble-chart-condition-' + this.classId;
        this.gridChartTitle = 'grid-chart-title-' + this.classId;
        this.gridChartColumnsContainer = 'grid-chart-columns-' + this.classId;
        this.gridChartGroupBy = 'grid-chart-group-by-' + this.classId;
        this.gridChartRowsPerPage = 'grid-chart-rows-per-page-' + this.classId;
        this.gridChartRowLimit = 'grid-chart-row-limit-' + this.classId;
        this.gridChartDensity = 'grid-chart-density-' + this.classId;
        this.gridChartStickyFirstColumn = 'grid-chart-sticky-first-' + this.classId;
        this.gridChartBackgroundColor = 'grid-chart-background-color-' + this.classId;
        this.gridChartFontColor = 'grid-chart-font-color-' + this.classId;
        this.gridChartTitleFontSize = 'grid-chart-title-font-size-' + this.classId;
        this.gridChartFieldCondition = 'grid-chart-condition-' + this.classId;
        this.chartTypes = [
            {
                id: this.chartTypeCard, name: 'CardChart', typeKey: 'Card', titleKey: 'CardChart',
                icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="8" height="8" rx="1.5"/><rect x="13" y="3" width="8" height="8" rx="1.5"/><rect x="3" y="13" width="8" height="8" rx="1.5"/><rect x="13" y="13" width="8" height="8" rx="1.5"/></svg>',
                create: (chartId) => this._createCardChart(chartId)
            },
            {
                id: this.chartTypePie, name: 'PieChart', typeKey: 'Pie', titleKey: 'PieChart',
                icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 3 V12 L19.5 16.5"/></svg>',
                create: (chartId) => this._createPieChart(chartId)
            },
            {
                id: this.chartTypeLine, name: 'LineChart', typeKey: 'Line', titleKey: 'LineChart',
                icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3 V21 H21"/><path d="M6 16 L10 11 L14 13 L18 6" stroke-width="2"/></svg>',
                create: (chartId) => this._createLineOrBarChart(chartId, 'Line')
            },
            {
                id: this.chartTypeBar, name: 'BarChart', typeKey: 'Bar', titleKey: 'BarChart',
                icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3 V21 H21"/><rect x="6" y="13" width="3" height="8"/><rect x="11" y="8" width="3" height="13"/><rect x="16" y="16" width="3" height="5"/></svg>',
                create: (chartId) => this._createLineOrBarChart(chartId, 'Bar')
            },
            {
                id: this.chartTypeBubble, name: 'BubbleChart', typeKey: 'Bubble', titleKey: 'BubbleChart',
                icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3 V21 H21"/><circle cx="9" cy="16" r="2"/><circle cx="15" cy="10" r="3"/><circle cx="18.5" cy="15" r="1.5"/></svg>',
                create: (chartId) => this._createBubbleChart(chartId)
            },
            {
                id: this.chartTypeGrid, name: 'GridChart', typeKey: 'Grid', titleKey: 'GridChart',
                icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="1.5"/><path d="M3 9 H21"/><path d="M3 14 H21"/><path d="M10 4 V20"/></svg>',
                create: (chartId) => this._createGridChart(chartId)
            }
        ];
    }

    init() {
        $event.register(eventTypes.CHART_UPDATE, this._getUpdateChartHandler(), this, this.classId);
    }

    _getUpdateChartHandler() {
        var handler = async (eventName, data, sender) => {
            await this.editChart(data.layerId, data.chartId);
        };

        return handler;
    }

    async editChart(layerId, chartId) {
        this._ensurePickerStyles();
        let layer = this.layerSettingsHandler.getLayerSettings(layerId);
        this.currentLayer = layer;
        this.currentLayerFields = await this._getLayerInfo(layer);

        let chartType = this.chartTypes.find(t => t.typeKey === layer.Charts[chartId].type) || this.chartTypes[0];
        this._createChart(chartType, chartId);
    }

    async addNewChart(layer) {
        if (layer) {
            this.currentLayer = layer;
            this.currentLayerFields = await this._getLayerInfo(layer);

            this._initChartSettingsPanel();
        }
    }

    _initChartSettingsPanel() {
        this.modalContainer.innerHTML = this._getChartSettingsTemplate();

        $(`#${this.cancelChartSettingsId}`).on("click", () => {
            document.getElementById(this.chartSettingsWrapper).remove();
        });

        this._initSettingsControls();
    }

    _initSettingsControls() {
        this._ensurePickerStyles();
        this.chartTypes.forEach((chartType, index) => {
            this._renderChartOptionItem(chartType, index);
        });
    };

    _renderChartOptionItem(chartType, index) {
        let title = this._getChartTitle(chartType);
        let entry = this.chartTypes.find(t => t.id === chartType.id);
        let tile = document.createElement('div');
        tile.id = chartType.id;
        tile.className = 'xp-chart-type-tile';
        tile.style.setProperty('--xp-i', index);
        tile.setAttribute('title', title);

        let iconWrap = document.createElement('span');
        iconWrap.className = 'xp-chart-type-tile-icon';
        iconWrap.innerHTML = entry ? entry.icon : '';

        let label = document.createElement('span');
        label.className = 'xp-chart-type-tile-label';
        label.textContent = title;

        tile.appendChild(iconWrap);
        tile.appendChild(label);
        tile.addEventListener('click', () => this._createChart(chartType));

        $(`#${this.chartTypeSelectId}`).append(tile);
    }

    _ensurePickerStyles() {
        if (document.getElementById('xp-chart-picker-styles')) return;

        let style = document.createElement('style');
        style.id = 'xp-chart-picker-styles';
        style.textContent =
            '.xp-chart-settings-modal .xp-chart-modal-header {' +
                'background:var(--theme-primary-700);padding:10px 14px;' +
                'margin:-8px 0 12px -8px !important;width:calc(100% + 24px);' +
            '}' +
            '.xp-chart-settings-modal .xp-chart-modal-header .general-settings-title {' +
                'color:#fff;font-weight:600;margin:0 !important;font-size:14px;line-height:1.4;' +
            '}' +
            '.xp-chart-section-title {' +
                'display:flex;align-items:center;gap:10px;' +
                'margin:14px 0 10px 0;padding:0;' +
                'font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.08em;' +
                'color:var(--theme-primary-700);' +
            '}' +
            '.xp-chart-section-title::after {' +
                'content:"";flex:1;height:1px;background:var(--theme-primary-700);opacity:0.25;' +
            '}' +
            '.xp-chart-section-title:first-child {' +
                'margin-top:0;' +
            '}' +
            '.xp-chart-settings-modal .form-label {' +
                'font-size:12px;margin-bottom:3px;color:#555;font-weight:500;' +
            '}' +
            '.xp-chart-settings-modal .col-6.mb-3,' +
            '.xp-chart-settings-modal .col-12.mb-3,' +
            '.xp-chart-settings-modal .col-xl-12.mb-3 {' +
                'margin-bottom:10px !important;' +
            '}' +
            '.xp-chart-settings-modal input[type="color"].form-control {' +
                'cursor:pointer;transition:border-color 0.15s ease;' +
            '}' +
            '.xp-chart-settings-modal input[type="color"].form-control:hover {' +
                'border-color:var(--theme-primary-700);' +
            '}' +
            '.xp-chart-type-picker {' +
                'display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));' +
                'gap:12px;margin-top:8px;padding:4px;' +
            '}' +
            '.xp-chart-type-tile {' +
                'display:flex;flex-direction:column;align-items:center;justify-content:center;' +
                'padding:14px 8px;background:#ffffff;border:1px solid #E5E5E5;border-radius:8px;' +
                'cursor:pointer;user-select:none;opacity:0;' +
                'transition:transform 0.2s ease,box-shadow 0.2s ease,border-color 0.2s ease;' +
                'animation:xp-chart-type-fade-in 0.3s ease both;' +
                'animation-delay:calc(var(--xp-i, 0) * 60ms);' +
            '}' +
            '.xp-chart-type-tile:hover {' +
                'transform:translateY(-3px);' +
                'box-shadow:0 4px 12px rgba(0,0,0,0.12);' +
                'border-color:var(--theme-primary-700);' +
            '}' +
            '.xp-chart-type-tile-icon {' +
                'display:inline-flex;width:56px;height:56px;color:#555;' +
                'transition:color 0.2s ease;pointer-events:none;' +
            '}' +
            '.xp-chart-type-tile-icon svg {' +
                'width:100%;height:100%;' +
            '}' +
            '.xp-chart-type-tile:hover .xp-chart-type-tile-icon {' +
                'color:var(--theme-primary-700);' +
            '}' +
            '.xp-chart-type-tile-label {' +
                'margin-top:10px;font-size:12px;font-weight:500;color:#333;text-align:center;' +
            '}' +
            '@keyframes xp-chart-type-fade-in {' +
                'from { opacity:0; transform:translateY(8px); }' +
                'to { opacity:1; transform:translateY(0); }' +
            '}';

        document.head.appendChild(style);
    }

    _createChart(chartType, chartId) {
        let entry = this.chartTypes.find(t => t.id === chartType.id);
        if (entry) entry.create(chartId);
    }

    _createCardChart(chartId) {
        this.queryBuilderInited = false;
        let chart = chartId != null ? this.currentLayer.Charts[chartId] : null;
        this.modalContainer.innerHTML = this._getCardChartSettingsTemplate();
        this._wireCardChart(chart);
        this._wireSaveAndCancel(this.cardChartFieldCondition, chartId, (condition) => this._buildCardChartData(condition));
        this._initQueryBuilderFor(this.cardChartFieldCondition, chart);
    }

    _wireCardChart(chart) {
        if (chart != null) {
            $('#' + this.cardChartTitle).val(chart.title);
            if (chart.backgroundColor) $('#' + this.cardChartBackgroundColor).val(chart.backgroundColor);
            if (chart.fontColor) $('#' + this.cardChartFontColor).val(chart.fontColor);
            if (chart.titleFontSize) $('#' + this.cardChartTitleFontSize).val(chart.titleFontSize);
            if (chart.valueFontSize) $('#' + this.cardChartValueFontSize).val(chart.valueFontSize);
            if (chart.maxCategories) $('#' + this.cardChartMaxCategories).val(chart.maxCategories);
            if (chart.cardsPerRow) $('#' + this.cardChartCardsPerRow).val(chart.cardsPerRow);
        }

        $('#' + this.cardChartField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.field : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.cardChartAggregationMethod).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.aggregation : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getAggregationDataSource()
        });

        $('#' + this.cardChartCategoryField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.categoryField : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.cardChartSortOrder).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.sortOrder || 'asc') : 'asc',
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getSortOrderDataSource()
        });

        $('#' + this.cardChartColorPalette).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.colorPalette || 'default') : 'default',
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getColorPaletteDataSource(),
            change: () => {
                this.chartFilterBuilder.toggleCustomColors(this.cardChartColorPalette, this.cardChartCustomColors);
            }
        });

        this.chartFilterBuilder.initCustomColorsPicker(this.cardChartCustomColors, chart);
    }

    _buildCardChartData(condition) {
        return {
            title: $('#' + this.cardChartTitle).val(),
            type: 'Card',
            field: $('#' + this.cardChartField).data('kendoComboBox').value(),
            aggregation: $('#' + this.cardChartAggregationMethod).data('kendoComboBox').value(),
            categoryField: $('#' + this.cardChartCategoryField).data('kendoComboBox').value(),
            maxCategories: $('#' + this.cardChartMaxCategories).val(),
            cardsPerRow: $('#' + this.cardChartCardsPerRow).val(),
            sortOrder: $('#' + this.cardChartSortOrder).data('kendoComboBox').value(),
            colorPalette: $('#' + this.cardChartColorPalette).data('kendoComboBox').value(),
            customColors: this.chartFilterBuilder.getCustomColors(this.cardChartCustomColors),
            condition: condition,
            backgroundColor: $('#' + this.cardChartBackgroundColor).val(),
            fontColor: $('#' + this.cardChartFontColor).val(),
            titleFontSize: $('#' + this.cardChartTitleFontSize).val(),
            valueFontSize: $('#' + this.cardChartValueFontSize).val(),
            userHandled: true
        };
    }

    _initQueryBuilderFor(containerId, item) {
        if (this.queryBuilderInited) return;

        let filters = [];

        this.currentLayerEntityFields.forEach((entityField) => {
            filters.push(this.chartFilterBuilder.getConditionFilter(entityField, '', ''));
        });

        filters.push({
            id: 'eval',
            label: 'eval',
            type: 'string',
            operators: ['sql'],
            input: (rule, name) => {
                return `<textarea class="form-control" style="min-width: 44vw;"></textarea>`;
            },
            valueGetter: (rule) => {
                return rule.$el.find('textarea').val();
            },
            valueSetter: (rule, value) => {
                return rule.$el.find('textarea').val(value);
            }
        });

        let queryBuilderOptions = { filters: filters };

        if (item != null && item.condition != null && item.condition.trim() != '') {
            let parsedRules = this.chartFilterBuilder.sanitizeRules(JSON.parse(item.condition));
            if (parsedRules != null) queryBuilderOptions.rules = parsedRules;
        }

        $('#' + containerId).queryBuilder(queryBuilderOptions);

        this.queryBuilderInited = true;
    }

    _getChartTitle(chartType) {
        let entry = this.chartTypes.find(t => t.id === chartType.id);
        return entry ? this.resourcesHandler.get(entry.titleKey) : '';
    }

    _getCardChartSettingsTemplate() {
        return `<div class="general-settings-wrapper panel config-modal xp-chart-settings-modal" id="` + this.chartSettingsWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 px-2 pb-0" style="overflow: hidden; overflow-y: auto;">
                            <div class="form-row m-0 xp-chart-modal-header">
                                <label class="form-label general-settings-title ml-2">` + this.resourcesHandler.get('CardChartConfiguration') + `</label>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionData') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartTitle') + `</label>
                                                    <input class="form-control" id="` + this.cardChartTitle + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartField') + `</label>
                                                    <input class="form-control" id="` + this.cardChartField + `">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartAggregationMethod') + `</label>
                                                    <input class="form-control" id="` + this.cardChartAggregationMethod + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartCategoryField') + `</label>
                                                    <input class="form-control" id="` + this.cardChartCategoryField + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartMaxCategories') + `</label>
                                                    <input type="number" class="form-control" id="` + this.cardChartMaxCategories + `" value="10" step="1" min="1">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartCardsPerRow') + `</label>
                                                    <input type="number" class="form-control" id="` + this.cardChartCardsPerRow + `" step="1" min="0" placeholder="` + this.resourcesHandler.get('Auto') + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('SortOrder') + `</label>
                                                    <input class="form-control" id="` + this.cardChartSortOrder + `">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartColorPalette') + `</label>
                                                    <input class="form-control" id="` + this.cardChartColorPalette + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0" id="` + this.cardChartCustomColors + `" style="display:none;">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CustomColors') + `</label>
                                                    <div id="` + this.cardChartCustomColors + `-list" class="d-flex flex-wrap align-items-center" style="gap:4px;"><button type="button" class="btn btn-sm btn-secondary" style="padding-left:0.2rem;padding-right:0.2rem;" id="` + this.cardChartCustomColors + `-add">+</button></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionAppearance') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BackgroundColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.cardChartBackgroundColor + `" value="#ffffff">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('FontColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.cardChartFontColor + `" value="#000000">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('TitleFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.cardChartTitleFontSize + `" value="10" step="1" min="1">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('ValueFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.cardChartValueFontSize + `" value="20" step="1" min="1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionFilter') + `</div>
                                        <div class="form-row">
                                            <div class="col-xl-12 mb-3">
                                                <div class="form-group">
                                                    <div id="` + this.cardChartFieldCondition + `"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelChartSettingsId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveChartSettingsId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanged') + `" type="button">` + this.resourcesHandler.get('Save') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _createPieChart(chartId) {
        this.queryBuilderInited = false;
        let chart = chartId != null ? this.currentLayer.Charts[chartId] : null;
        this.modalContainer.innerHTML = this._getPieChartSettingsTemplate();
        this._wirePieChart(chart);
        this._wireSaveAndCancel(this.pieChartFieldCondition, chartId, (condition) => this._buildPieChartData(condition));
        this._initQueryBuilderFor(this.pieChartFieldCondition, chart);
    }

    _wirePieChart(chart) {
        if (chart != null) {
            $('#' + this.pieChartTitle).val(chart.title);
            if (chart.backgroundColor) $('#' + this.pieChartBackgroundColor).val(chart.backgroundColor);
            if (chart.fontColor) $('#' + this.pieChartFontColor).val(chart.fontColor);
            if (chart.maxSlices) $('#' + this.pieChartMaxSlices).val(chart.maxSlices);
            if (chart.titleFontSize) $('#' + this.pieChartTitleFontSize).val(chart.titleFontSize);
            if (chart.labelFontSize) $('#' + this.pieChartLabelFontSize).val(chart.labelFontSize);
        }

        $('#' + this.pieChartCategoryField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.categoryField : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.pieChartValueField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.valueField : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.pieChartAggregationMethod).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.aggregation : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getAggregationDataSource()
        });

        $('#' + this.pieChartLabelType).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.labelType : 'percentage',
            suggest: true,
            ignoreCase: true,
            dataSource: [{
                id: 'percentage',
                name: this.resourcesHandler.get('LabelTypePercentage')
            }, {
                id: 'value',
                name: this.resourcesHandler.get('LabelTypeValue')
            }]
        });

        $('#' + this.pieChartColorPalette).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.colorPalette || 'default') : 'default',
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getColorPaletteDataSource(),
            change: () => {
                this.chartFilterBuilder.toggleCustomColors(this.pieChartColorPalette, this.pieChartCustomColors);
            }
        });

        this.chartFilterBuilder.initCustomColorsPicker(this.pieChartCustomColors, chart);
    }

    _buildPieChartData(condition) {
        return {
            title: $('#' + this.pieChartTitle).val(),
            type: 'Pie',
            categoryField: $('#' + this.pieChartCategoryField).data('kendoComboBox').value(),
            valueField: $('#' + this.pieChartValueField).data('kendoComboBox').value(),
            aggregation: $('#' + this.pieChartAggregationMethod).data('kendoComboBox').value(),
            maxSlices: $('#' + this.pieChartMaxSlices).val(),
            backgroundColor: $('#' + this.pieChartBackgroundColor).val(),
            fontColor: $('#' + this.pieChartFontColor).val(),
            titleFontSize: $('#' + this.pieChartTitleFontSize).val(),
            labelFontSize: $('#' + this.pieChartLabelFontSize).val(),
            labelType: $('#' + this.pieChartLabelType).data('kendoComboBox').value(),
            colorPalette: $('#' + this.pieChartColorPalette).data('kendoComboBox').value(),
            customColors: this.chartFilterBuilder.getCustomColors(this.pieChartCustomColors),
            condition: condition,
            userHandled: true
        };
    }

    _getPieChartSettingsTemplate() {
        return `<div class="general-settings-wrapper panel config-modal xp-chart-settings-modal" id="` + this.chartSettingsWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 px-2 pb-0" style="overflow: hidden; overflow-y: auto;">
                            <div class="form-row m-0 xp-chart-modal-header">
                                <label class="form-label general-settings-title ml-2">` + this.resourcesHandler.get('PieChartConfiguration') + `</label>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionData') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('PieChartTitle') + `</label>
                                                    <input class="form-control" id="` + this.pieChartTitle + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('PieChartCategoryField') + `</label>
                                                    <input class="form-control" id="` + this.pieChartCategoryField + `">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('PieChartValueField') + `</label>
                                                    <input class="form-control" id="` + this.pieChartValueField + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CardChartAggregationMethod') + `</label>
                                                    <input class="form-control" id="` + this.pieChartAggregationMethod + `">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('PieChartMaxSlices') + `</label>
                                                    <input type="number" class="form-control" id="` + this.pieChartMaxSlices + `" value="10" step="1" min="1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionAppearance') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BackgroundColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.pieChartBackgroundColor + `" value="#ffffff">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('FontColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.pieChartFontColor + `" value="#000000">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('TitleFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.pieChartTitleFontSize + `" value="12" step="1" min="1">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('LabelFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.pieChartLabelFontSize + `" value="10" step="1" min="1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('PieChartLabelType') + `</label>
                                                    <input class="form-control" id="` + this.pieChartLabelType + `">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('PieChartColorPalette') + `</label>
                                                    <input class="form-control" id="` + this.pieChartColorPalette + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0" id="` + this.pieChartCustomColors + `" style="display:none;">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('CustomColors') + `</label>
                                                    <div id="` + this.pieChartCustomColors + `-list" class="d-flex flex-wrap align-items-center" style="gap:4px;"><button type="button" class="btn btn-sm btn-secondary" style="padding-left:0.2rem;padding-right:0.2rem;" id="` + this.pieChartCustomColors + `-add">+</button></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionFilter') + `</div>
                                        <div class="form-row">
                                            <div class="col-xl-12 mb-3">
                                                <div class="form-group">
                                                    <div id="` + this.pieChartFieldCondition + `"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelChartSettingsId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveChartSettingsId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanged') + `" type="button">` + this.resourcesHandler.get('Save') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _createLineOrBarChart(chartId, chartType) {
        this.queryBuilderInited = false;
        let chart = chartId != null ? this.currentLayer.Charts[chartId] : null;
        let configTitle = chartType === 'Bar' ? this.resourcesHandler.get('BarChartConfiguration') : this.resourcesHandler.get('LineChartConfiguration');
        this.modalContainer.innerHTML = this._getLineChartSettingsTemplate(configTitle);
        this._wireLineOrBarChart(chart, chartType);
        this._wireSaveAndCancel(this.lineChartFieldCondition, chartId, (condition) => this._buildLineOrBarChartData(condition, chartType));
        this._initQueryBuilderFor(this.lineChartFieldCondition, chart);
    }

    _wireLineOrBarChart(chart, chartType) {
        if (chart != null) {
            $('#' + this.lineChartTitle).val(chart.title);
            if (chart.backgroundColor) $('#' + this.lineChartBackgroundColor).val(chart.backgroundColor);
            if (chart.fontColor) $('#' + this.lineChartFontColor).val(chart.fontColor);
            if (chart.titleFontSize) $('#' + this.lineChartTitleFontSize).val(chart.titleFontSize);
            if (chart.labelFontSize) $('#' + this.lineChartLabelFontSize).val(chart.labelFontSize);
            $('#' + this.lineChartAreaFill).prop('checked', !!chart.areaFill);
            $('#' + this.lineChartStackedArea).prop('checked', !!chart.stackedArea);
            $('#' + this.lineChartBarStacked).prop('checked', !!chart.stacked);
        }

        document.getElementById(this.lineChartAreaFillRow).style.display = chartType === 'Line' ? '' : 'none';
        document.getElementById(this.lineChartBarStackedRow).style.display = chartType === 'Bar' ? '' : 'none';

        $('#' + this.lineChartStackedArea).prop('disabled', !$('#' + this.lineChartAreaFill).is(':checked'));
        $('#' + this.lineChartAreaFill).on('change', () => {
            let on = $('#' + this.lineChartAreaFill).is(':checked');
            $('#' + this.lineChartStackedArea).prop('disabled', !on);
            if (!on) $('#' + this.lineChartStackedArea).prop('checked', false);
        });

        $('#' + this.lineChartXField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.xField : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.lineChartSortOrder).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.sortOrder || 'asc') : 'asc',
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getSortOrderDataSource()
        });

        let currentMode = chart != null ? (chart.seriesMode || 'manual') : 'manual';

        $('#' + this.lineChartSeriesMode).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: currentMode,
            suggest: true,
            ignoreCase: true,
            dataSource: [{
                id: 'manual',
                name: this.resourcesHandler.get('ManualSeries')
            }, {
                id: 'split',
                name: this.resourcesHandler.get('SplitBySeries')
            }],
            change: () => {
                let mode = $('#' + this.lineChartSeriesMode).data('kendoComboBox').value();
                document.getElementById(this.lineChartManualContainer).style.display = mode === 'manual' ? '' : 'none';
                document.getElementById(this.lineChartSplitContainer).style.display = mode === 'split' ? '' : 'none';
            }
        });

        document.getElementById(this.lineChartManualContainer).style.display = currentMode === 'manual' ? '' : 'none';
        document.getElementById(this.lineChartSplitContainer).style.display = currentMode === 'split' ? '' : 'none';

        this._initLineSeriesUI(chart);
        this._initLineSplitByUI(chart);
    }

    _buildLineOrBarChartData(condition, chartType) {
        let seriesMode = $('#' + this.lineChartSeriesMode).data('kendoComboBox').value() || 'manual';

        let chartData = {
            title: $('#' + this.lineChartTitle).val(),
            type: chartType,
            xField: $('#' + this.lineChartXField).data('kendoComboBox').value(),
            sortOrder: $('#' + this.lineChartSortOrder).data('kendoComboBox').value(),
            seriesMode: seriesMode,
            series: seriesMode === 'manual' ? this._getLineSeriesData() : [],
            splitByField: seriesMode === 'split' && $('#' + this.lineChartSplitByField).data('kendoComboBox') ? $('#' + this.lineChartSplitByField).data('kendoComboBox').value() : null,
            splitValueField: seriesMode === 'split' && $('#' + this.lineChartSplitValueField).data('kendoComboBox') ? $('#' + this.lineChartSplitValueField).data('kendoComboBox').value() : null,
            splitAggregation: seriesMode === 'split' && $('#' + this.lineChartSplitAggregation).data('kendoComboBox') ? $('#' + this.lineChartSplitAggregation).data('kendoComboBox').value() : null,
            colorPalette: seriesMode === 'split' && $('#' + this.lineChartSplitColorPalette).data('kendoComboBox') ? $('#' + this.lineChartSplitColorPalette).data('kendoComboBox').value() : 'default',
            customColors: seriesMode === 'split' ? this.chartFilterBuilder.getCustomColors(this.lineChartSplitCustomColors) : [],
            backgroundColor: $('#' + this.lineChartBackgroundColor).val(),
            fontColor: $('#' + this.lineChartFontColor).val(),
            titleFontSize: $('#' + this.lineChartTitleFontSize).val(),
            labelFontSize: $('#' + this.lineChartLabelFontSize).val(),
            condition: condition,
            userHandled: true
        };

        if (chartType === 'Line') {
            chartData.areaFill = $('#' + this.lineChartAreaFill).is(':checked');
            chartData.stackedArea = $('#' + this.lineChartStackedArea).is(':checked');
        } else if (chartType === 'Bar') {
            chartData.stacked = $('#' + this.lineChartBarStacked).is(':checked');
        }

        return chartData;
    }

    _initLineSplitByUI(chart) {
        $('#' + this.lineChartSplitByField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.splitByField : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.lineChartSplitValueField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? chart.splitValueField : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.lineChartSplitAggregation).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.splitAggregation || 'COUNT') : 'COUNT',
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getAggregationDataSource({ includeCountUnique: false, includeMedian: false })
        });

        $('#' + this.lineChartSplitColorPalette).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.colorPalette || 'default') : 'default',
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getColorPaletteDataSource(),
            change: () => {
                this.chartFilterBuilder.toggleCustomColors(this.lineChartSplitColorPalette, this.lineChartSplitCustomColors);
            }
        });

        this.chartFilterBuilder.initCustomColorsPicker(this.lineChartSplitCustomColors, chart);
    }

    _initLineSeriesUI(chart) {
        let container = document.getElementById(this.lineChartSeriesContainer + '-list');
        let addBtn = document.getElementById(this.lineChartSeriesContainer + '-add');

        let existingSeries = (chart != null && Array.isArray(chart.series)) ? chart.series : [];

        if (existingSeries.length === 0) {
            this._addLineSeriesRow(container, addBtn, {});
        } else {
            existingSeries.forEach(s => {
                this._addLineSeriesRow(container, addBtn, s);
            });
        }

        addBtn.addEventListener('click', () => {
            this._addLineSeriesRow(container, addBtn, {});
        });
    }

    _addLineSeriesRow(container, addBtn, seriesData) {
        let row = document.createElement('div');
        row.className = 'form-row mb-1 line-series-row';
        row.style.cssText = 'align-items:center;';

        let nameId = 'ls-name-' + this._generateUUID();
        let fieldId = 'ls-field-' + this._generateUUID();
        let aggrId = 'ls-aggr-' + this._generateUUID();
        let colorId = 'ls-color-' + this._generateUUID();

        row.innerHTML =
            '<div class="col-3"><input class="form-control" id="' + nameId + '" placeholder="' + this.resourcesHandler.get('SeriesName') + '"></div>' +
            '<div class="col-3"><input class="form-control" id="' + fieldId + '"></div>' +
            '<div class="col-3"><input class="form-control" id="' + aggrId + '"></div>' +
            '<div class="col-2"><input type="color" class="form-control" id="' + colorId + '" value="' + (seriesData.color || '#008FFB') + '" style="padding:2px 2px 2px 0;height:35px;"></div>' +
            '<div class="col-1 text-center"><span class="ls-remove" style="cursor:pointer;font-size:16px;color:#999;">&times;</span></div>';

        row.dataset.nameId = nameId;
        row.dataset.fieldId = fieldId;
        row.dataset.aggrId = aggrId;
        row.dataset.colorId = colorId;

        container.insertBefore(row, addBtn);

        $('#' + nameId).val(seriesData.name || '');

        $('#' + fieldId).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: seriesData.yField || null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + aggrId).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: seriesData.aggregation || 'COUNT',
            suggest: true,
            ignoreCase: true,
            dataSource: this.chartFilterBuilder.getAggregationDataSource({ includeCountUnique: false, includeMedian: false })
        });

        row.querySelector('.ls-remove').addEventListener('click', () => {
            row.remove();
        });
    }

    _getLineSeriesData() {
        let container = document.getElementById(this.lineChartSeriesContainer + '-list');
        if (!container) return [];
        let rows = container.querySelectorAll('.line-series-row');
        let series = [];
        rows.forEach(row => {
            let nameVal = $('#' + row.dataset.nameId).val() || '';
            let fieldCombo = $('#' + row.dataset.fieldId).data('kendoComboBox');
            let aggrCombo = $('#' + row.dataset.aggrId).data('kendoComboBox');
            let colorVal = $('#' + row.dataset.colorId).val() || '#008FFB';
            series.push({
                name: nameVal,
                yField: fieldCombo ? fieldCombo.value() : '',
                aggregation: aggrCombo ? aggrCombo.value() : 'COUNT',
                color: colorVal
            });
        });
        return series;
    }

    _getLineChartSettingsTemplate(configTitle) {
        configTitle = configTitle || this.resourcesHandler.get('LineChartConfiguration');
        return `<div class="general-settings-wrapper panel config-modal xp-chart-settings-modal" id="` + this.chartSettingsWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 px-2 pb-0" style="overflow: hidden; overflow-y: auto;">
                            <div class="form-row m-0 xp-chart-modal-header">
                                <label class="form-label general-settings-title ml-2">` + configTitle + `</label>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionData') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('LineChartTitle') + `</label>
                                                    <input class="form-control" id="` + this.lineChartTitle + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('LineChartXField') + `</label>
                                                    <input class="form-control" id="` + this.lineChartXField + `">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('SortOrder') + `</label>
                                                    <input class="form-control" id="` + this.lineChartSortOrder + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('SeriesMode') + `</label>
                                                    <input class="form-control" id="` + this.lineChartSeriesMode + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div id="` + this.lineChartManualContainer + `">
                                            <div class="form-row mb-0">
                                                <div class="col-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this.resourcesHandler.get('LineChartSeries') + `</label>
                                                        <div id="` + this.lineChartSeriesContainer + `-list">
                                                            <button type="button" class="btn btn-sm btn-secondary mb-1" style="padding-left:0.2rem;padding-right:0.2rem;" id="` + this.lineChartSeriesContainer + `-add">+</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="` + this.lineChartSplitContainer + `">
                                            <div class="form-row mb-0">
                                                <div class="col-6 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this.resourcesHandler.get('SplitByField') + `</label>
                                                        <input class="form-control" id="` + this.lineChartSplitByField + `">
                                                    </div>
                                                </div>
                                                <div class="col-6 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this.resourcesHandler.get('SplitAggregation') + `</label>
                                                        <input class="form-control" id="` + this.lineChartSplitAggregation + `">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row mb-0">
                                                <div class="col-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this.resourcesHandler.get('SplitValueField') + `</label>
                                                        <input class="form-control" id="` + this.lineChartSplitValueField + `">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row mb-0">
                                                <div class="col-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this.resourcesHandler.get('ColorPalette') + `</label>
                                                        <input class="form-control" id="` + this.lineChartSplitColorPalette + `">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row mb-0" id="` + this.lineChartSplitCustomColors + `" style="display:none;">
                                                <div class="col-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this.resourcesHandler.get('CustomColors') + `</label>
                                                        <div id="` + this.lineChartSplitCustomColors + `-list" class="d-flex flex-wrap align-items-center" style="gap:4px;">
                                                            <button type="button" class="btn btn-sm btn-secondary" style="padding-left:0.2rem;padding-right:0.2rem;" id="` + this.lineChartSplitCustomColors + `-add">+</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionAppearance') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BackgroundColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.lineChartBackgroundColor + `" value="#ffffff">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('FontColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.lineChartFontColor + `" value="#000000">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('TitleFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.lineChartTitleFontSize + `" value="12" step="1" min="1">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('LabelFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.lineChartLabelFontSize + `" value="10" step="1" min="1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0" id="` + this.lineChartAreaFillRow + `" style="display:none;">
                                            <div class="col-6 mb-3">
                                                <div class="form-group form-check">
                                                    <input type="checkbox" class="form-check-input" id="` + this.lineChartAreaFill + `">
                                                    <label class="form-check-label" for="` + this.lineChartAreaFill + `">` + this.resourcesHandler.get('AreaFill') + `</label>
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group form-check">
                                                    <input type="checkbox" class="form-check-input" id="` + this.lineChartStackedArea + `">
                                                    <label class="form-check-label" for="` + this.lineChartStackedArea + `">` + this.resourcesHandler.get('StackedArea') + `</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0" id="` + this.lineChartBarStackedRow + `" style="display:none;">
                                            <div class="col-6 mb-3">
                                                <div class="form-group form-check">
                                                    <input type="checkbox" class="form-check-input" id="` + this.lineChartBarStacked + `">
                                                    <label class="form-check-label" for="` + this.lineChartBarStacked + `">` + this.resourcesHandler.get('StackedBars') + `</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionFilter') + `</div>
                                        <div class="form-row">
                                            <div class="col-xl-12 mb-3">
                                                <div class="form-group">
                                                    <div id="` + this.lineChartFieldCondition + `"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelChartSettingsId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveChartSettingsId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanged') + `" type="button">` + this.resourcesHandler.get('Save') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _createBubbleChart(chartId) {
        this.queryBuilderInited = false;
        let chart = chartId != null ? this.currentLayer.Charts[chartId] : null;
        this.modalContainer.innerHTML = this._getBubbleChartSettingsTemplate();
        this._wireBubbleChart(chart);
        this._wireSaveAndCancel(this.bubbleChartFieldCondition, chartId, (condition) => this._buildBubbleChartData(condition));
        this._initQueryBuilderFor(this.bubbleChartFieldCondition, chart);
    }

    _wireBubbleChart(chart) {
        if (chart != null) {
            $('#' + this.bubbleChartTitle).val(chart.title);
            if (chart.backgroundColor) $('#' + this.bubbleChartBackgroundColor).val(chart.backgroundColor);
            if (chart.fontColor) $('#' + this.bubbleChartFontColor).val(chart.fontColor);
            if (chart.titleFontSize) $('#' + this.bubbleChartTitleFontSize).val(chart.titleFontSize);
            if (chart.labelFontSize) $('#' + this.bubbleChartLabelFontSize).val(chart.labelFontSize);
            if (chart.maxBubbleSize) $('#' + this.bubbleChartMaxBubbleSize).val(chart.maxBubbleSize);
        }

        $('#' + this.bubbleChartXField).kendoComboBox({
            dataTextField: 'Name', dataValueField: 'Name', filter: 'contains',
            syncValueAndText: false, value: chart != null ? chart.xField : null,
            suggest: true, ignoreCase: true, dataSource: this.currentLayerFields
        });

        $('#' + this.bubbleChartYField).kendoComboBox({
            dataTextField: 'Name', dataValueField: 'Name', filter: 'contains',
            syncValueAndText: false, value: chart != null ? chart.yField : null,
            suggest: true, ignoreCase: true, dataSource: this.currentLayerFields
        });

        $('#' + this.bubbleChartSizeField).kendoComboBox({
            dataTextField: 'Name', dataValueField: 'Name', filter: 'contains',
            syncValueAndText: false, value: chart != null ? chart.sizeField : null,
            suggest: true, ignoreCase: true, dataSource: this.currentLayerFields
        });

        $('#' + this.bubbleChartSplitByField).kendoComboBox({
            dataTextField: 'Name', dataValueField: 'Name', filter: 'contains',
            syncValueAndText: false, value: chart != null ? chart.splitByField : null,
            suggest: true, ignoreCase: true, dataSource: this.currentLayerFields
        });

        $('#' + this.bubbleChartNullHandling).kendoComboBox({
            dataTextField: 'name', dataValueField: 'id', filter: 'contains',
            syncValueAndText: false, value: chart != null ? (chart.nullHandling || 'skip') : 'skip',
            suggest: true, ignoreCase: true,
            dataSource: [
                { id: 'skip', name: this.resourcesHandler.get('NullHandlingSkip') },
                { id: 'zero', name: this.resourcesHandler.get('NullHandlingZero') }
            ]
        });

        $('#' + this.bubbleChartColorPalette).kendoComboBox({
            dataTextField: 'name', dataValueField: 'id', filter: 'contains',
            syncValueAndText: false, value: chart != null ? (chart.colorPalette || 'default') : 'default',
            suggest: true, ignoreCase: true,
            dataSource: this.chartFilterBuilder.getColorPaletteDataSource(),
            change: () => {
                this.chartFilterBuilder.toggleCustomColors(this.bubbleChartColorPalette, this.bubbleChartCustomColors);
            }
        });

        this.chartFilterBuilder.initCustomColorsPicker(this.bubbleChartCustomColors, chart);
    }

    _buildBubbleChartData(condition) {
        return {
            title: $('#' + this.bubbleChartTitle).val(),
            type: 'Bubble',
            xField: $('#' + this.bubbleChartXField).data('kendoComboBox').value(),
            yField: $('#' + this.bubbleChartYField).data('kendoComboBox').value(),
            sizeField: $('#' + this.bubbleChartSizeField).data('kendoComboBox') ? $('#' + this.bubbleChartSizeField).data('kendoComboBox').value() : null,
            splitByField: $('#' + this.bubbleChartSplitByField).data('kendoComboBox') ? $('#' + this.bubbleChartSplitByField).data('kendoComboBox').value() : null,
            maxBubbleSize: $('#' + this.bubbleChartMaxBubbleSize).val(),
            nullHandling: $('#' + this.bubbleChartNullHandling).data('kendoComboBox') ? $('#' + this.bubbleChartNullHandling).data('kendoComboBox').value() : 'skip',
            colorPalette: $('#' + this.bubbleChartColorPalette).data('kendoComboBox') ? $('#' + this.bubbleChartColorPalette).data('kendoComboBox').value() : 'default',
            customColors: this.chartFilterBuilder.getCustomColors(this.bubbleChartCustomColors),
            backgroundColor: $('#' + this.bubbleChartBackgroundColor).val(),
            fontColor: $('#' + this.bubbleChartFontColor).val(),
            titleFontSize: $('#' + this.bubbleChartTitleFontSize).val(),
            labelFontSize: $('#' + this.bubbleChartLabelFontSize).val(),
            condition: condition,
            userHandled: true
        };
    }

    _getBubbleChartSettingsTemplate() {
        return `<div class="general-settings-wrapper panel config-modal xp-chart-settings-modal" id="` + this.chartSettingsWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 px-2 pb-0" style="overflow: hidden; overflow-y: auto;">
                            <div class="form-row m-0 xp-chart-modal-header">
                                <label class="form-label general-settings-title ml-2">` + this.resourcesHandler.get('BubbleChartConfiguration') + `</label>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionData') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BubbleChartTitle') + `</label>
                                                    <input class="form-control" id="` + this.bubbleChartTitle + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-4 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BubbleChartXField') + `</label>
                                                    <input class="form-control" id="` + this.bubbleChartXField + `">
                                                </div>
                                            </div>
                                            <div class="col-4 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BubbleChartYField') + `</label>
                                                    <input class="form-control" id="` + this.bubbleChartYField + `">
                                                </div>
                                            </div>
                                            <div class="col-4 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BubbleChartSizeField') + `</label>
                                                    <input class="form-control" id="` + this.bubbleChartSizeField + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('SplitByField') + `</label>
                                                    <input class="form-control" id="` + this.bubbleChartSplitByField + `">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('MaxBubbleSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.bubbleChartMaxBubbleSize + `" value="20" step="1" min="5" max="50">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('NullHandling') + `</label>
                                                    <input class="form-control" id="` + this.bubbleChartNullHandling + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('ColorPalette') + `</label>
                                                    <input class="form-control" id="` + this.bubbleChartColorPalette + `">
                                                </div>
                                            </div>
                                            <div class="form-row mb-0" id="` + this.bubbleChartCustomColors + `" style="display:none;">
                                                <div class="col-12 mb-3">
                                                    <div class="form-group">
                                                        <label class="form-label">` + this.resourcesHandler.get('CustomColors') + `</label>
                                                        <div id="` + this.bubbleChartCustomColors + `-list" class="d-flex flex-wrap align-items-center" style="gap:4px;">
                                                            <button type="button" class="btn btn-sm btn-secondary" style="padding-left:0.2rem;padding-right:0.2rem;" id="` + this.bubbleChartCustomColors + `-add">+</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionAppearance') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BackgroundColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.bubbleChartBackgroundColor + `" value="#ffffff">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('FontColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.bubbleChartFontColor + `" value="#000000">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('TitleFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.bubbleChartTitleFontSize + `" value="12" step="1" min="1">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('LabelFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.bubbleChartLabelFontSize + `" value="10" step="1" min="1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionFilter') + `</div>
                                        <div class="form-row">
                                            <div class="col-xl-12 mb-3">
                                                <div class="form-group">
                                                    <div id="` + this.bubbleChartFieldCondition + `"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelChartSettingsId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveChartSettingsId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanged') + `" type="button">` + this.resourcesHandler.get('Save') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _createGridChart(chartId) {
        this.queryBuilderInited = false;
        let chart = chartId != null ? this.currentLayer.Charts[chartId] : null;
        this.modalContainer.innerHTML = this._getGridChartSettingsTemplate();
        this._wireGridChart(chart);
        this._wireSaveAndCancel(this.gridChartFieldCondition, chartId, (condition) => this._buildGridChartData(condition));
        this._initQueryBuilderFor(this.gridChartFieldCondition, chart);
    }

    _wireGridChart(chart) {
        if (chart != null) {
            $('#' + this.gridChartTitle).val(chart.title);
            if (chart.backgroundColor) $('#' + this.gridChartBackgroundColor).val(chart.backgroundColor);
            if (chart.fontColor) $('#' + this.gridChartFontColor).val(chart.fontColor);
            if (chart.titleFontSize) $('#' + this.gridChartTitleFontSize).val(chart.titleFontSize);
            if (chart.rowsPerPage) $('#' + this.gridChartRowsPerPage).val(chart.rowsPerPage);
            if (chart.rowLimit) $('#' + this.gridChartRowLimit).val(chart.rowLimit);
            $('#' + this.gridChartStickyFirstColumn).prop('checked', !!chart.stickyFirstColumn);
        }

        $('#' + this.gridChartGroupBy).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.groupBy || null) : null,
            suggest: true,
            ignoreCase: true,
            dataSource: this.currentLayerFields
        });

        $('#' + this.gridChartDensity).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'id',
            filter: 'contains',
            syncValueAndText: false,
            value: chart != null ? (chart.density || 'compact') : 'compact',
            suggest: true,
            ignoreCase: true,
            dataSource: [
                { id: 'compact', name: this.resourcesHandler.get('GridChartDensityCompact') },
                { id: 'comfortable', name: this.resourcesHandler.get('GridChartDensityComfortable') }
            ]
        });

        this._wireGridColumns(chart);
    }

    _wireGridColumns(chart) {
        let listEl = document.getElementById(this.gridChartColumnsContainer + '-list');
        let addBtnEl = document.getElementById(this.gridChartColumnsContainer + '-add');
        this._gridColumnEditor = new GridColumnEditor({
            listEl: listEl,
            addBtnEl: addBtnEl,
            getResource: (k) => this.resourcesHandler.get(k),
            getFields: () => this.currentLayerFields,
            fieldTextField: 'Name',
            fieldValueField: 'Name'
        });
        this._gridColumnEditor.setColumns(chart && chart.columns);
    }

    _getGridColumns() {
        return this._gridColumnEditor ? this._gridColumnEditor.getColumns() : [];
    }

    _buildGridChartData(condition) {
        let groupByCombo = $('#' + this.gridChartGroupBy).data('kendoComboBox');
        return {
            title: $('#' + this.gridChartTitle).val(),
            type: 'Grid',
            columns: this._getGridColumns(),
            groupBy: groupByCombo ? (groupByCombo.value() || null) : null,
            rowsPerPage: parseInt($('#' + this.gridChartRowsPerPage).val(), 10) || 20,
            rowLimit: parseInt($('#' + this.gridChartRowLimit).val(), 10) || 1000,
            density: $('#' + this.gridChartDensity).data('kendoComboBox').value() || 'compact',
            stickyFirstColumn: $('#' + this.gridChartStickyFirstColumn).is(':checked'),
            backgroundColor: $('#' + this.gridChartBackgroundColor).val(),
            fontColor: $('#' + this.gridChartFontColor).val(),
            titleFontSize: $('#' + this.gridChartTitleFontSize).val(),
            condition: condition,
            userHandled: true
        };
    }

    _getGridChartSettingsTemplate() {
        return `<div class="general-settings-wrapper panel config-modal xp-chart-settings-modal" id="` + this.chartSettingsWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 px-2 pb-0" style="overflow: hidden; overflow-y: auto;">
                            <div class="form-row m-0 xp-chart-modal-header">
                                <label class="form-label general-settings-title ml-2">` + this.resourcesHandler.get('GridChartConfiguration') + `</label>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionData') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('GridChartTitle') + `</label>
                                                    <input class="form-control" id="` + this.gridChartTitle + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('GridChartColumns') + `</label>
                                                    <div id="` + this.gridChartColumnsContainer + `">
                                                        <div id="` + this.gridChartColumnsContainer + `-list"></div>
                                                        <button type="button" class="btn btn-sm btn-secondary mt-1" id="` + this.gridChartColumnsContainer + `-add">+ ` + this.resourcesHandler.get('GridChartAddColumn') + `</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('GridChartGroupBy') + `</label>
                                                    <input class="form-control" id="` + this.gridChartGroupBy + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-4 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('GridChartRowsPerPage') + `</label>
                                                    <input type="number" class="form-control" id="` + this.gridChartRowsPerPage + `" value="20" step="1" min="1">
                                                </div>
                                            </div>
                                            <div class="col-4 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('GridChartRowLimit') + `</label>
                                                    <input type="number" class="form-control" id="` + this.gridChartRowLimit + `" value="1000" step="1" min="1">
                                                </div>
                                            </div>
                                            <div class="col-4 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('GridChartDensity') + `</label>
                                                    <input class="form-control" id="` + this.gridChartDensity + `">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-12 mb-3">
                                                <div class="form-group form-check">
                                                    <input type="checkbox" class="form-check-input" id="` + this.gridChartStickyFirstColumn + `">
                                                    <label class="form-check-label" for="` + this.gridChartStickyFirstColumn + `">` + this.resourcesHandler.get('GridChartStickyFirstColumn') + `</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionAppearance') + `</div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('BackgroundColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.gridChartBackgroundColor + `" value="#ffffff">
                                                </div>
                                            </div>
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('FontColor') + `</label>
                                                    <input type="color" class="form-control" style="padding:2px 2px 2px 0;height:35px;" id="` + this.gridChartFontColor + `" value="#000000">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-row mb-0">
                                            <div class="col-6 mb-3">
                                                <div class="form-group">
                                                    <label class="form-label">` + this.resourcesHandler.get('TitleFontSize') + `</label>
                                                    <input type="number" class="form-control" id="` + this.gridChartTitleFontSize + `" value="12" step="1" min="1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="xp-chart-section-title">` + this.resourcesHandler.get('ChartSectionFilter') + `</div>
                                        <div class="form-row">
                                            <div class="col-xl-12 mb-3">
                                                <div class="form-group">
                                                    <div id="` + this.gridChartFieldCondition + `"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelChartSettingsId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                            <button id="` + this.saveChartSettingsId + `" class="btn btn-primary ml-2" title="` + this.resourcesHandler.get('SaveChanged') + `" type="button">` + this.resourcesHandler.get('Save') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    _getChartSettingsTemplate() {
        return `<div class="general-settings-wrapper panel config-modal xp-chart-settings-modal" id="` + this.chartSettingsWrapper + `">
                    <div class="general-settings-panel panel-container">
                        <div class="panel-content pt-2 px-2 pb-0" style="overflow: hidden; overflow-y: auto;">
                            <div class="form-row m-0 xp-chart-modal-header">
                                <label class="form-label general-settings-title ml-2">` + this.resourcesHandler.get('ChartConfiguration') + `</label>
                            </div>
                            <div class="form-row mb-0">
                                <div class="col-xl-12 mb-3">
                                    <div class="form-group">
                                        <label class="form-label mt-3 ml-2">` + this.resourcesHandler.get('SelectChartType') + `</label>
                                        <div class="xp-chart-type-picker" id="` + this.chartTypeSelectId + `">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right">
                            <button id="` + this.cancelChartSettingsId + `" class="btn btn-secondary ml-auto" title="` + this.resourcesHandler.get('CancelChanges') + `" type="button">` + this.resourcesHandler.get('Cancel') + `</button>
                        </div>
                    </div>
                </div>`;
    }

    async _getLayerInfo(layer) {
        if (Object.keys(layer).find(x => x.toLocaleLowerCase() == 'geoservice')) {
            let response = await fetch(this.rootUrl + paths.MAP_GEOSERVICE_FIELDS_DESCRIPTOR + layer.IdGeoService, {
                method: "GET"
            });

            let json = await response.json();

            this.currentLayerEntityFields = json;
            return json;
        } else if(Object.keys(layer).find(x => x.toLocaleLowerCase() == 'entity')){
            let entityId = layer.Entity.Id;

            let response = await fetch(this.rootUrl + paths.MAP_ENTITY_GET_FIELDS + entityId, {
                method: "GET"
            });

            let json = await response.json();

            let fields = [];
            json.forEach(x => {
                fields.push({
                    Name: x.FieldName,
                    Attributes: [{
                        Name: 'type',
                        Value: x.DataType
                    }],
                    Id: x.Id,
                    DataType: x.DataType
                });
            });

            this.currentLayerEntityFields = json;

            return fields;
        }
        return [];
    }

    _wireSaveAndCancel(conditionContainerId, chartId, buildDataFn) {
        $(`#${this.cancelChartSettingsId}`).on("click", () => {
            document.getElementById(this.chartSettingsWrapper).remove();
        });

        $(`#${this.saveChartSettingsId}`).on("click", () => {
            if (this.currentLayer.Charts == null) {
                this.currentLayer.Charts = {};
            }
            let chartCondition;
            if (this.queryBuilderInited) {
                let queryConditions = $('#' + conditionContainerId).queryBuilder('getRules', { allow_invalid: true });
                if (queryConditions != null) {
                    chartCondition = JSON.stringify(queryConditions);
                }
            }
            let chartData = buildDataFn(chartCondition);
            this._emitChartSave(chartData, chartId);
        });
    }

    _emitChartSave(chartData, chartId) {
        if (chartId == null) {
            chartData.id = this._generateUUID();
            $event.notify(eventTypes.CHART_ADDED, { chart: chartData, layerId: this.currentLayer.Id }, this, this.classId);
        } else {
            chartData.id = chartId;
            $event.notify(eventTypes.CHART_UPDATED, { chart: chartData, layerId: this.currentLayer.Id }, this, this.classId);
        }
        document.getElementById(this.chartSettingsWrapper).remove();
    }

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }
}